import {gql} from 'apollo-angular';

export const GET_TEACHING_IDEA_TYPES = gql`
  query GetTeachingIdeaTypes {
    teachingIdeaTypes {
      id
      typeName
    }
  }
`;


